import { createFileRoute, useRouter } from "@tanstack/react-router";

import { NewNewsPage } from "@/features/content/pages";

export const Route = createFileRoute("/_app/growth/news/new")({
  component: NewNews,
});

function NewNews() {
  const router = useRouter();
  return (
    <NewNewsPage
      onCreated={(newsId) =>
        void router.navigate({ to: "/growth/news/$newsId", params: { newsId }, replace: true })
      }
      onCancel={() => void router.navigate({ to: "/growth/news" })}
    />
  );
}
